import React from 'react'

import { MapProvider } from '../../components/Map/MapProvider'
import { MapRender } from '../../components/Map/MapRender'
import { DeliveryTypeEnum } from '../../graph/generated'
import { DeliveryMap } from './DeliveryMap'
import { PickupMap } from './PickupMap'

type TProps = TFactoryProps &
  SomeChildren & {
    isMobile?: boolean
    orderMethod: DeliveryTypeEnum
  }

type TFactoryProps = {
  onConfirm(): void
}

const mapByOrderMethod = {
  [DeliveryTypeEnum.Messenger]: React.createFactory<TFactoryProps>(DeliveryMap),
  [DeliveryTypeEnum.Pickup]: React.createFactory<TFactoryProps>(PickupMap),
}

export const OrderMap: React.FC<TProps> = ({
  children,
  isMobile,
  orderMethod,
  onConfirm,
}) => {
  return (
    <MapProvider>
      <MapRender isMobile={isMobile} doubleClickZoom scrollZoom />
      {mapByOrderMethod[orderMethod]({ onConfirm })}
      {children}
    </MapProvider>
  )
}
